var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-details",
    transform: "translate(-1826 -858)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 24,
    height: 24,
    transform: "translate(1826 858)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_175",
    "data-name": "Trac\\xE9 175",
    d: "M13.2,2.268,16.446,7.9a1,1,0,0,1-.366,1.366l-1.3.749,1,1.733-1.732,1-1-1.733-1.3.751a1,1,0,0,1-1.366-.366L8.546,8.215a5.006,5.006,0,0,0-3.222,6.561,5,5,0,0,1,6.755,1.333l7.688-4.438,1,1.732L12.89,17.951A5.05,5.05,0,0,1,12.9,20H21v2H4a5,5,0,0,1-.19-5.731A7,7,0,0,1,7.527,6.449l-.393-.682a2,2,0,0,1,.732-2.732l2.6-1.5A2,2,0,0,1,13.2,2.268ZM8,16a3,3,0,0,0-2.829,4h5.659A3,3,0,0,0,8,16ZM11.464,3.268l-2.6,1.5,2.75,4.763,2.6-1.5Z",
    transform: "translate(1826 857.732)",
    fill: "#5777ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDetails);
export default __webpack_public_path__ + "static/media/ico-details.8a2d47d8bd3aec40e30a6122e261bb4b.svg";
export { ForwardRef as ReactComponent };